import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Sets an Place Set as default or not
 * @param setId Set ID of the Place Set
 * @param defaultSet Whether the Place Set will be set as default
 */
export function putPlaceSetsDefault(
  this: unknown,
  setId: number,
  defaultSet: boolean
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment
          .resolve(this)
          .placeSetsIdDefaultUrl(setId)}/${defaultSet.toString()}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
